export var OrderStatusEnum;
(function (OrderStatusEnum) {
    OrderStatusEnum["DELAYED"] = "delayed";
    OrderStatusEnum["DELAYED_PAY"] = "delayed_pay";
    OrderStatusEnum["NEW"] = "new";
    OrderStatusEnum["RECEIVED"] = "received";
    OrderStatusEnum["READY"] = "ready";
    OrderStatusEnum["COMPLETE"] = "complete";
    OrderStatusEnum["CANCELED"] = "canceled";
    OrderStatusEnum["CLEARED"] = "cleared";
    OrderStatusEnum["REFUNDED"] = "refunded";
    OrderStatusEnum["TEST"] = "test";
})(OrderStatusEnum || (OrderStatusEnum = {}));
//# sourceMappingURL=OrderStatusEnum.js.map